"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
const baseError_1 = require("../../../models/error/baseError");
class ValidationError extends baseError_1.BaseError {
    constructor(code) {
        super('Validation Error');
        this.code = code;
    }
    getCode() {
        return this.code;
    }
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=ValidationError.js.map